import {useMemo} from 'react';

import {OrderLine} from '../../transport/apiServiceResponse';
import useStorePriceDisplayConditions from '../usePriceDisplayConditions';

import {resolvePricing} from './resolvers/frontendResolver';
import {PricingIntent, ResolvedPricing} from './types';

export function useResolvedPricing(
  item: OrderLine,
  intent: PricingIntent = 'transactional',
): ResolvedPricing {
  const {showMemberPrice} = useStorePriceDisplayConditions();

  return useMemo(
    () => resolvePricing(item, showMemberPrice, intent),
    [item, showMemberPrice, intent],
  );
}
